import { QueryParams } from '../constants';
export const generateCartUrl = (cartQrId, dealerId) => {
    const url = new URL(window.location.href);
    url.searchParams.set(QueryParams.HASHED_CART_ID, cartQrId);
    url.searchParams.set(QueryParams.PRESELECTED_DEALER_ID, dealerId);
    return url.toString();
};
